const isActionKey = (key) => {
  if (key === 'Enter' || key === 'Space') {
    return true;
  }
  return false;
};

export { isActionKey };
